import { render } from "./manufacturer-coupon-page.vue?vue&type=template&id=5c194094&scoped=true&ts=true"
import script from "./manufacturer-coupon-page.vue?vue&type=script&lang=ts"
export * from "./manufacturer-coupon-page.vue?vue&type=script&lang=ts"

import "./manufacturer-coupon-page.vue?vue&type=style&index=0&id=5c194094&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c194094"]])

export default __exports__